module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "8146.73960b57.jpg";